module.exports = __webpack_public_path__ + "img/notests.c720178e.svg";